import type { EmailTemplate } from "@redotech/redo-model/email-template";
import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";

import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const updateSavedEmailTemplate = {
  input: z.object({
    savedTemplateId: zExt.objectId(),
    updates: z
      .object({
        template: (emailTemplateSchema as z.ZodType<EmailTemplate>).optional(),
      })
      .partial(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
